<template>
  <div class="policy-detail-container">
    <!-- <div class="banner-size">
      <div class="banner-limit banner-info">

      </div>
    </div> -->
    <div class="banner-limit policy-detail-content" style="min-height: 24px">
      <img src="~@/assets/images/positionImg.png" alt="" style="" />
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="font-size: 18px; display: inline-block; margin-left: 8px"
      >
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/searchList' }" v-if="linkType"
          >分类搜索</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{
          detailType == 2 ? "小微企业专栏详情" : "政策详情"
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div
      class="banner-limit flex-column flex-start policy-detail-content"
      ref="noticeDDetail"
    >
      <!--侧边栏导航目录,是扶持政策则显示-->
      <!--      <div v-if="collectType==2" style="position: fixed;left:100px">
        <Anchor show-ink offset-top="offsetTop">
          <AnchorLink
            v-for="(menu, i) in menus"
            :key="i"
            :href="`#${menu.name}`"
            :title="menu.category">
          </AnchorLink>
        </Anchor>
      </div> -->
      <div v-if="itemData" class="flex-row-between detail-wrap">
        <div class="flex-column flex-start detail-left">
          <!-- 标题 -->
          <div
            class="detail-title flex-center"
            style="border-bottom: 3px solid #333; padding-bottom: 10px"
          >
            <h2>{{ itemData.name }}</h2>
            <div class="flex-row flex-center title-wrap">
              <!-- <div>
              </div> -->
              <!--              <p>{{ itemData.areaname }}</p>-->
              <!--              <p>时间：{{ itemData.createTime }}</p>-->
              <!-- <a @click="collectOrCancel">{{
                collectItemId != "" ? "取消收藏" : "收藏"
              }}</a> -->
              <!--<span>发文字号：{{ itemData.fwzh }}</span
              >&nbsp;&nbsp;&nbsp;-->
              <span style="margin-right: 50px;" v-if="detailType == 2">发布机构：{{ itemData.fbjg }}</span>
              <span>发布时间：{{ itemData.publictime }}</span>
            </div>
          </div>

          <div class="ql-editor" v-html="itemData.content" style="margin-bottom: 30px;"></div>

          <!-- <div class="attachment-container">
            <p>相关附件</p>
          </div> -->
          <!-- <img
            class="bottom-img"
            src="@/assets/images/detail_bottom_icon.png"
          /> -->
        </div>
        <!-- right -->
        <div class="detail-right">
          <!--政策的右边,相关政策改为相关通知 1是代表未当前是扶持政策页面-->
          <CardRight
            v-if="deptObject != null"
            :deptObject="deptObject"
            :id="id"
          ></CardRight>
        </div>
        <!--登录提示弹窗-->
        <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
          <span>需要登录才能收藏，是否登录？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="gotoLogin">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    <div class="sideNav flexStyle2" v-show="showSideNav">
      <i class="fold" @click="fold"></i>
      <div
        @click="toNewPage('onlineConsult')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-chat-line-round"></i>在线咨询
      </div>
      <div
        @click="toNewPage('phoneConsult')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-phone"></i>电话咨询
      </div>
      <div
        @click="toNewPage('handleConsult')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-s-claim"></i>在线办理
      </div>
      <div
        @click="toNewPage('orderConsult')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-user-solid"></i>预约专家团队咨询
      </div>
      <div
        @click="toNewPage('complaintConsult')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-phone-outline"></i>在线投诉
      </div>
      <div
        @click="toNewPage('onlineJudge')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-chat-line-round"></i>在线评价
      </div>
      <div v-show="!foldFlag" class="foldTxt flexStyle2">快捷功能</div>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import CardRight from "@/components/cardRight";
import { Loading } from "element-ui";

export default {
  components: {
    CardRight,
  },
  data() {
    return {
      foldFlag: true,
      showSideNav: false, //控制显示侧边栏
      dialogVisible: false,
      detailFalg: "", //展示详情，如通知公告详情
      id: "",
      offsetTop: 28,
      //部门信息,右边需要显示
      deptObject: null,
      menus: [
        {
          id: 0,
          name: "jibenxinxi",
          category: "政策详情",
        },
        {
          id: 1,
          name: "jibenxinxi",
          category: "政策解读",
        },
      ],
      itemData: null,
      //collectType 对应 type
      //1 通知 -> 2通知公告
      // 2 政策 -> 1项目政策
      // 3 信息公示 -> 3公开公示
      type: 0, //请求事项列表传的type参数
      collectType: 0, //收藏接口传的type参数
      collectItemId: "",
      linkType: false,
      detailType: 1,
    };
  },
  created() {
    this.$route.query.showSideNav;
    if (this.$route.query.showSideNav) {
      this.showSideNav = this.$route.query.showSideNav;
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    const that = this;
    const id = that.$route.params.id; // 接收的参数ID
    that.id = id;
    that.type = that.$route.query.type;

    // that.linkType=that.$route.query.linkType
    that.detailType = that.$route.query.detailType;
    that.linkType = sessionStorage.getItem("linkType");
    let detail = sessionStorage.getItem("detailType");
    if (detail) {
      that.detailType = Number(detail);
    }
    that.getNoticeInfo(id);
    //collectType 对应 type
    //1 通知 -> 2通知公告
    // 2 政策 -> 1项目政策
    // 3 信息公示 -> 3公开公示
    let type = this.type;

    this.collectType = 3;
    if (type == "1") {
      this.collectType = 2;
    }
    if (type == "2") {
      this.collectType = 1;
    }

    //查询当前项目是否被收藏
    this.isItemCollect();
  },
  methods: {
    cutout(cellValue) {
      if(cellValue.length>10){
        cellValue = cellValue.substr(0, 10);
      }
      return cellValue
    },
    fold() {
      let navFix = document.querySelector(".sideNav");
      let arrow = document.querySelector(".fold");
      this.foldFlag = !this.foldFlag;
      if (this.foldFlag) {
        navFix.style.background = "red";
        navFix.style.borderColor = "red";
        arrow.style.right = "0%";
        arrow.style.top = "465px";
      } else {
        navFix.style.background = "transparent";
        navFix.style.borderColor = "transparent";
        arrow.style.right = "0%";
        arrow.style.top = "270px";
      }
    },
    handleScroll() {
      let navFix = document.querySelector(".sideNav");
      let sy =
        window.pageYOffset ||
        document.body.scrollTo ||
        document.documentElement.scrollTop;
      navFix.style.position = "fixed";
      navFix.style.top = "200px";
      navFix.style.zIndex = 1000;
    },
    toNewPage(param) {
      switch (param) {
        case "orderConsult":
        case "handleConsult":
        case "phoneConsult":
          // this.tabInfo.active = "PolicyConsult";
          this.$router.push("/policyService");
          sessionStorage.setItem("tabInfo_active", "PolicyConsult");
          sessionStorage.setItem("showFlag", param);
          break;
        case "onlineConsult":
          let href = "https://12366.chinatax.gov.cn/xiaohui/";
          window.open(href, "_blank");
          break;
        case "complaintConsult":
          let href2 =
            "https://henan.chinatax.gov.cn/luohe/hdjl/sswfxwjj/wyxx/index.html";
          window.open(href2, "_blank");
          break;
        case "onlineJudge":
          let href3 = "https://www.wjx.cn/vj/tG73KG4.aspx";
          window.open(href3, "_blank");
          break;
        default:
          break;
      }
    },
    getTitle() {
      if (this.collectType == 1) {
        return "通知公告";
      }
      if (this.collectType == 2) {
        return "扶持政策";
      }
      if (this.collectType == 3) {
        return "信息公示";
      }
      return "";
    },
    gotoDeclare() {
      if (this.$store.getters.getUserInfo) {
        let childItem = this.$refs.guideCenter.childItem;
        this.$store.commit("updateCurrentDeclareItem", childItem);
        this.$router.push({
          name: "declare",
        });
      } else {
        this.$router.push({
          name: "login",
        });
      }
    },
    /**
     * 监听declareCeil子组件点击收藏事件
     */
    clickIsFollow(item) {
      //判断是否登录
      if (this.$store.getters.getUserInfo) {
        //登录
      } else {
        //未登录
        this.dialogVisible = true;
      }
    },
    /**
     * 登录提示框点击确定登录，跳转登录页面
     */
    gotoLogin() {
      console.log("跳转登录页面");
      this.$router.push({
        path: "/login",
      });
    },
    /**
     * 公告详细信息
     * @param {string} id 传项目id
     */
    getNoticeInfo(id) {
      let loadingnoticeDDetail = Loading.service({
        target: this.$refs.noticeDDetail,
      });
      let that = this;
      if (id) {
        this.$httpApi
          .get(`/dev-api/document/${id}`, { type: this.detailType })
          //.get(`/dev-api/policyexplain/${id}`, { type: this.detailType })
          .then((res) => {
            console.log("公告详细信息:", res);
            if (res.code == 200) {
              loadingnoticeDDetail.close();
              that.itemData = res.data;
              let data = res.data;
              that.deptObject = {
                deptName: data.deptname,
                deptId: data.deptid,
                fbjg: data.fbjg,
                remark: data.remark,
                fileId: data.fileId
              };
            }
          })
          .catch((err) => {
            loadingnoticeDDetail.close();
          });
      }
    },
    //收藏或取消收藏
    collectOrCancel() {
      if (this.$store.getters.getUserInfo) {
        let flag = this.collectItemId != "";
        if (flag) {
          this.cancelCollect();
        } else {
          this.collect();
        }
      } else {
        this.$router.push({
          name: "login",
        });
      }
    },
    //查询当前是否已被收藏
    isItemCollect() {
      if (this.$store.getters.getUserInfo) {
        let identify = this.$store.getters.getUserInfo.shxydm;
        let id = this.id;
        let param = {
          identify: identify,
          collectionid: id,
          type: this.collectType,
          pageNum: 1,
          pageSize: 10,
        };
        let url = "/dev-api/collection/list";
        this.$httpApi
          .get(url, param)
          .then((res) => {
            console.log("是否收藏" + JSON.stringify(res));
            if (res.code == 200) {
              if (res.rows.length > 0) {
                this.collectItemId = res.rows[0].id;
              } else {
                this.collectItemId = "";
              }
            }
          })
          .catch((err) => {});
      }
    },
    //收藏
    collect() {
      let item = this.itemData;
      let identify = this.$store.getters.getUserInfo.tyshxydm;
      let param = {
        collectionName: item.name,
        collectionId: item.id,
        identify: identify,
        type: this.collectType,
      };
      let that = this;
      that.$httpApi
        .post("/dev-api/collection/install", param)
        .then((res) => {
          console.log("添加收藏" + JSON.stringify(res));
          if (res.code == 200 && res.data) {
            that.collectItemId = res.id;
          }
          if (res.msg == "已收藏，无需重复收藏") {
            that.collectItemId = identify;
          }
        })
        .catch((err) => {});
    },
    //取消收藏
    cancelCollect() {
      let collectItemId = this.collectItemId;
      this.$httpApi
        .post("/dev-api/collection/delete/" + collectItemId, {})
        .then((res) => {
          console.log("取消收藏" + JSON.stringify(res));
          if (res.code == 200) {
            this.collectItemId = "";
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.flexStyle2 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
}
.policy-detail-container {
  position: relative;
  .sideNav {
    width: 100px;
    height: 460px;
    border: 1px solid red;
    color: #fff;
    background: red;
    position: absolute;
    right: 5px;
    top: 60px;
    z-index: 1000;
    .fold {
      display: block;
      width:100%;
      height:50px;
      border: 1px solid red;
      background-color: red;
      background-image: url("~@/assets/images/fold1.png");
      background-position: center center;
      background-repeat: no-repeat;
      position: absolute;
      right: 0;
      top: 460px;
      font-size: 20px;
      cursor: pointer;
    }
    .foldTxt {
      width: 100px;
      height: 70px;
      margin-right:1px;
      font-size: 18px;
      border-radius: 3px;
      text-align: center;
      background-color: red;
      color:#fff;
    }
    .rotate {
      transform: rotate(180deg);
    }
    div {
      min-height: 50px;
      width: 70px;
      padding: 5px;
      border-radius: 3px;
      font-size: 14px;
      cursor: pointer;
      margin: 7px 0;
      &:hover {
        // color: #ffef69;
        background-color: #ff9000;
      }
      i {
        font-size: 30px;
        display: block;
      }
    }
  }
}
.banner-size {
  background: url("~@/assets/images/sub_banner.png") no-repeat 100% / cover;
}

.banner-info {
  height: 100%;
  display: flex;
  align-items: center;
  .banner-fMax {
    font-size: 40px;
  }

  .banner-other {
    margin-left: 20px;
    font-size: 20px;
  }
}
.policy-detail-content {
  margin-top: 30px;
  min-height: 400px;
}

.detail-wrap {
  width: 100%;
  align-items: flex-start;

  /* 左右 */
  .detail-left {
    flex: 1;
    align-self: flex-start;
    margin-right: 30px;
    overflow: hidden;
  }

  .detail-right {
    width: 300px;
  }
}

.detail-title {
  color: #333;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;

  h1 {
    width: 100%;
    align-self: flex-start;
    padding-bottom: 10px;
    border-bottom: 0.1875rem solid #0d1c28;

    // margin-bottom: 20px;
  }

  p {
    padding: 10px 0;
  }

  .title-wrap {
    width: 100%;
    height: 36px;
    color: #aaaaaa;
  }
}

.detail-content {
  line-height: 28px;
  font-size: 18px;
  margin: 20px 0;
  overflow: hidden;

  p {
    text-indent: 2rem;
  }
}

/* 附件 */
.attachment-container {
  width: 100%;

  p {
    padding-bottom: 0.3125rem;
    font-size: 1.25rem;
    border-bottom: 0.1875rem solid #0d1c28;
    color: #1d1e1f;
  }

  a {
    display: block;
    height: 40px;
    padding: 10px 0;
  }
}

/* 底部图片 */
.bottom-img {
  margin-top: 20px;
  width: 100%;
}

</style>
<style>
.ql-editor img{
  width: 100%;
}
</style>
